import { Button, useMediaQuery, useTheme } from '@mui/material';
import { Trans } from '@lingui/macro';

import { ListButtonsColumn } from '../../../../modules/dashboard/lists/ListButtonsColumn';
import { useModalContext } from '../../../../hooks/useModal';

export interface ILeverageActionsProps {
  tokenId?: string;
}

export const SupplyActions = ({ tokenId }: ILeverageActionsProps) => {
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));

  return md ? (
    <ListButtonsColumn size="small">
      <SupplyButton tokenId={tokenId} />
    </ListButtonsColumn>
  ) : (
    <SupplyButton tokenId={tokenId} />
  );
};

const SupplyButton = ({ tokenId }: ILeverageActionsProps) => {
  const { openSupplyPosition } = useModalContext();
  return (
    <Button
      variant="contained"
      onClick={() => {
        tokenId && openSupplyPosition(tokenId);
        window.gtag('event', 'lending_supply_click', {
          asset: 'Uniswap position',
        });
      }}
    >
      <Trans>Supply</Trans>
    </Button>
  );
};
